import { render, staticRenderFns } from "./EmptyMailboxSection.vue?vue&type=template&id=0d4d556e&scoped=true"
import script from "./EmptyMailboxSection.vue?vue&type=script&lang=js"
export * from "./EmptyMailboxSection.vue?vue&type=script&lang=js"
import style0 from "./EmptyMailboxSection.vue?vue&type=style&index=0&id=0d4d556e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d556e",
  null
  
)

export default component.exports